import { DatePipe } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { AddpartyComponent } from '../../party/addparty/addparty.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard';
import { AddrawmaterialComponent } from '../../rawmaterial/addrawmaterial/addrawmaterial.component';
import { AddrecipedetailComponent } from '../addrecipedetail/addrecipedetail.component';

@Component({
  selector: 'app-addrecipe',
  templateUrl: './addrecipe.component.html',
  styleUrls: ['./addrecipe.component.css']
})
export class AddrecipeComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ischeck: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;



  israwmaterialaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";

  //Edit Get Values
  recipemainColl: any = [];

  recipeBO: any = {}

  recipedetailscoll: any = [];

  ismanualclose: boolean;

  qtytotal: number = 0;

  productfindColl: any=[];
  uomColl: any;
  rawmaterialColl: any;
  isLoadingResult: boolean;

  recipeform = new FormGroup({
    recipeid:new FormControl(null),
    productid: new FormControl(null, Validators.required),
    productname: new FormControl(null),
    productvariationsid: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Recipe";

  gridfocusrow: number = -1;

  productname: any = ""


  @Input() productid: number = 0
  @Input() productvariationsid: number = 0
  
  @Input() formmode: String = "";


  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.recipeform.reset();
      this.fnInitializeForm();


      if (this.productid > 0) {
        this.fngetRecipe();
      }
      else {
        this.fnSetFirstRowItem()
      }

      this.fngetProduct();
      this.fnGetRawmaterial();
      this.fnGetUom();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }




  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.productid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.israwmaterialaddmode = this.loginService.fnCheckUserRoleAction("Rawmaterial", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeForm() {
    this.recipeform.setValue({
      recipeid:null,
      productname:null,
      productid: null,
      productvariationsid:null,
      inactive: false,
    })
  }



  fngetProduct() {
    var data = {
      'partyid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getProductReceipe(data)
      .subscribe(
        (res) => {
          var result = res.json().result
         // console.log(result)

          var productColl=result[0]
          var productvarianceColl=result[1]

          for (let abo of productColl) {
           // console.log(abo)
            this.productfindColl.push(abo);
          }

          for (let abo of productvarianceColl) {
            this.productfindColl.push(abo);
          }

          //console.log( this.productfindColl)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }




  //Get 
  fngetRecipe() {

    var data = {
      'productid': this.productid,
      'productvariationsid':this.productvariationsid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getRecipe(data)
      .subscribe(
        (res) => {
          //console.log(res.json())
          var result = res.json().result;

          this.recipedetailscoll = result[0];
          //console.log(this.recipedetailscoll)

       

          if (this.recipedetailscoll.length > 0) {
            this.productname = this.recipedetailscoll[0].productname


            var editdata = this.recipedetailscoll[0];
            this.recipeBO = editdata;
            this.fnEditMode();
          }

          if (this.recipedetailscoll.length === 0) {
            this.fnSetFirstRowItem()
          }
          this.fnCalcDetails();
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;

    for (let row of this.recipedetailscoll) {
      if (row.rawmaterialid > 0) {
        _detailscheck = true;
      }
    }

    if (!_detailscheck) {
      this.errtxt = "Recipe Details cannot be empty"
      this.recipeform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }
    if (!_ischeck) {
      for (let row of this.recipedetailscoll) {

        if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
          this.errtxt = "Quantity is cannot be empty"
          this.recipeform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }

      }
    }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.recipeform.get('inactive')) {
      this.recipeform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.recipeform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          'productid': this.recipeform.get('productid').value,
          'productvariationsid': this.recipeform.get('productvariationsid').value,
          'inactive': this.recipeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'recipedetailscoll': this.recipedetailscoll,
        }

        if (this.recipeform.get('recipeid').value > 0) {

          this.fnSetRecipe(data);
        }
        else {

          this.fnInsertRecipe(data);
        }

      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }

  //Insert
  fnInsertRecipe(data) {

    this.appService.fnInsertRecipe(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The new Recipe has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.recipeno);

          this.ismanualclose = true;
          this.fnCloseForm();

          // var _result = res.json().result;
          // if (_result.length > 0) {
          //   this.fnEditFormEdit(_result[0].recipeid);
          // }

        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetRecipe(data) {

    this.appService.fnSetRecipe(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The Recipe has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.productid, data.recipeno);

          this.fnEditFormEdit(this.productid);
        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }


  private fnEditMode() {
    this.recipeform.setValue({
      recipeid: this.recipeBO.recipeid,
      productid: this.recipeBO.productid,
      productname: this.recipeBO.productname,
      productvariationsid: this.recipeBO.productvariationsid,
      inactive: false,

    });




    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = false;

    if (this.formmode === 'EDIT') {
      this.iseditmode = true;
    }
    else {
      this.isviewmode = true;
    }
  }


  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }




  fnEditFormEdit(id) {

    this.productid = id;
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;


    //this.ngOnInit();

    this.ismanualclose = true;
    this.fnCloseForm();

  }

  //Close
  async fnCloseForm() {

    try {

      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;


      this.emitData.emit("");
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  @HostListener('window:beforeunload')
  canDeactivate(): any {

    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  //Details

  fnGetRawmaterial() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadRawmaterial(index) {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.fnChangeRawmaterial(index)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetUom() {
    this.isLoadingResult = true;

    var data = {
      'uomid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getUom(data)
      .subscribe(
        (res) => {
          this.uomColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnCalcDetails() {

    this.fnCalcsSummaryTotal()
  }




  fnCalcsSummaryTotal() {
    this.qtytotal = 0;



    for (let row of this.recipedetailscoll) {
      this.qtytotal = Number(this.fnConvertDecimal(this.qtytotal)) + Number(this.fnConvertDecimal(row.qty))

    }

  }




  fnDeleteRecipeConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.recipedetailscoll.splice(index, 1)
            if (this.recipedetailscoll.length === 0) {
              this.fnSetFirstRowItem()
            }
            this.fnCalcDetails()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnChangeRawmaterial(index) {

    var _prodname = "", _uomid = null, _unitprice = 0, _taxid = null;

    for (let abo of this.rawmaterialColl) {
      if (this.recipedetailscoll[index].rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _unitprice = abo.recipeprice;
        _uomid = abo.uomid;
        _taxid = abo.taxid;
      }
    }
    this.recipedetailscoll[index].rawmaterialname = _prodname;
    this.recipedetailscoll[index].unitprice = _unitprice;
    this.recipedetailscoll[index].uomid = _uomid;
    this.recipedetailscoll[index].taxid = _taxid;

    // this.fnChangeTax(index)
  }


  fnChangeTax(index) {

    var _uomname = "";

    // var _cgsttaxrate = 0, _sgsttaxrate = 0, _igsttaxrate = 0;

    for (let abo of this.uomColl) {
      if (this.recipedetailscoll[index].uomid === abo.uomid) {
        _uomname = abo.uomname;
        //     _taxrate = abo.taxrate;
        //     _cgsttaxrate = abo.cgsttaxrate;
        //     _sgsttaxrate = abo.sgsttaxrate;
        //     _igsttaxrate = abo.igsttaxrate;
      }
    }
    this.recipedetailscoll[index].uomname = _uomname;
    // this.recipedetailscoll[index].taxrate = _taxrate;
    // this.recipedetailscoll[index].cgsttaxrate = _cgsttaxrate;
    // this.recipedetailscoll[index].sgsttaxrate = _sgsttaxrate;
    // this.recipedetailscoll[index].igsttaxrate = _igsttaxrate;

    this.fnCalcDetails()

  }


  fnSetFirstRowItem() {
    if (this.recipedetailscoll.length > 0) {
      if (!this.recipedetailscoll[this.recipedetailscoll.length - 1].rawmaterialid) {
        return
      }
    }

    var data = {
      recipedetailsid: 0,
      rawmaterialid: null,
      rawmaterialname: '',
      qty: 0,
      uomid: null,
    }

    this.recipedetailscoll.push(data)

  }

  fnGetFirstRowItem() {

    var data = {
      recipedetailsid: null,
      recipeid: null,
      rawmaterialid: null,
      rawmaterialname: '',
      qty: null,
      unitprice: null,
      subtotal: null,
      uomid: null,
      taxid: null,
      taxname: '',
      taxrate: null,
      taxamt: null,
      cgsttaxrate: 0,
      cgsttaxamt: 0,
      sgsttaxrate: 0,
      sgsttaxamt: 0,
      igsttaxrate: 0,
      igsttaxamt: 0,
      taxable: 0,
      nettotal: null
    }

    return data;

  }


  //Focus
  fnFocusChangeGridRow(index) {
    this.gridfocusrow = index

  }

  fnSetNextFocus(index) {

    if (this.recipedetailscoll.length > 0) {

      if (this.recipedetailscoll.length > index + 1) {
        this.gridfocusrow = index + 1
      }
    }


  }


  //AddProduct
  private fnAddRawmaterial(index) {

    const modalRef = this.productFindService.open(AddrawmaterialComponent, { size: <any>'xxl' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetRawmaterial();

      if (receivedEntry > 0) {
        this.recipedetailscoll[index].rawmaterialid = receivedEntry
      }
      this.fnReLoadRawmaterial(index);

    });
  }

  fnchangeVariation() {
  var productname=this.recipeform.get("productname").value

  this.recipeform.patchValue({
    'productid':null,
    'productvariationsid':null
  })

  for(let abo of this.productfindColl){
    if(abo.productname===productname){
     
      this.recipeform.patchValue({
        'productid':abo.productid,
        'productvariationsid':abo.productvariationsid
      })
    }
  }


  }


  //Print
  // private fnPrintRecipe() {

  //   const modalRef = this.productFindService.open(PrintComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.recipeid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {



  //   });

  // }
  //Print
  // private fnGldetails() {

  //   const modalRef = this.productFindService.open(GldetailscommonComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.recipeid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //   });

  // }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  fnAddrecipeDetails() {

    const modalRef = this.productFindService.open(AddrecipedetailComponent, { size: <any>'l' });
    modalRef.componentInstance.purchasedetailsBO = this.fnGetFirstRowItem()
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry.checkstatus === "DONE") {
        this.fnSetFirstRowItem()
        this.recipedetailscoll[this.recipedetailscoll.length - 1] = receivedEntry.data;
        this.fnCalcDetails()
      }

    });
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
